import dayjs from 'dayjs';

const getToday = (): string => dayjs().startOf('day').toISOString();

export { getToday };
